module.exports = __webpack_public_path__ + "static/thumb-aviation-b172fbdef33b6ce5fefa3fc5f9cf33fd.png";